export default __webpack_public_path__ + "static/media/Sunset-Edited-480px-147px.24e67fdf.jpg";